import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Button, TextField, Paper, Typography, Box } from '@mui/material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { uploadAvatar, changePass } from '../../services/user-services';
import { toast } from 'react-toastify';
import User from "./user";


function Account() {

  const { authData, setAuth } = useAuth();
  const [image, setImage] = useState();
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  const passMatch = () => {
    return password === password2;
  }

  const processImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const size = 64;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');

          let sourceX, sourceY, sourceWidth, sourceHeight;
          if (img.width > img.height) {
            sourceWidth = img.height;
            sourceHeight = img.height;
            sourceX = (img.width - img.height) / 2;
            sourceY = 0;
          } else {
            sourceWidth = img.width;
            sourceHeight = img.width;
            sourceX = 0;
            sourceY = (img.height - img.width) / 2;
          }

          ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, size, size);
          canvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/jpeg', 0.8);
        };
        img.onerror = reject;
      };
      reader.onerror = reject;
    });
  }

  const uploadFile = async e => {
    e.preventDefault();
    if (!image) return;

    try {
      const resizedImage = await processImage(image);
      const uploadData = new FormData();
      uploadData.append('image', resizedImage, image.name);

      const uploaded = await uploadAvatar(authData.user.profile?.id, uploadData);
      if (uploaded) {
        toast.success("Image uploaded and resized");
        const newUser = { ...authData };
        newUser.user.profile = uploaded;
        setAuth(newUser);
      } else {
        toast.error("Error. Image was no uploaded");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error processing image");
    }
  }
  const submitChangePass = async e => {
    e.preventDefault();
    if (passMatch()) {
      const passData = await changePass(
        { old_password: oldPassword, new_password: password },
        authData.user.id,
        authData.token
      );
      if (passData) {
        toast.success("Password have been changed");
      }
    } else {
      toast.error("Password don't match");
    }
  }
  const logout = () => {
    setAuth(null);
  }


  return (
    <Box pb={4}>
      <Typography variant="h2" mb={3}>Account Settings</Typography>

      {authData && (
        <Box display="flex" flexDirection="column" gap={3}>
          {/* Profile Section */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid rgba(255,255,255,0.05)' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <User user={authData.user} />
              <Button size="small" variant="outlined" color="error" onClick={() => logout()}>
                Logout
              </Button>
            </Box>
          </Paper>

          {/* Avatar Upload */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid rgba(255,255,255,0.05)' }}>
            <Typography variant="h3" mb={2}>Change Avatar</Typography>
            <form onSubmit={uploadFile}>
              <Box display="flex" alignItems="center" gap={2}>
                <TextField
                  type="file"
                  size="small"
                  onChange={e => setImage(e.target.files[0])}
                  sx={{ flexGrow: 1 }}
                />
                <Button type="submit" variant="contained" color="primary">Upload</Button>
              </Box>
            </form>
          </Paper>

          {/* Password Change */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid rgba(255,255,255,0.05)' }}>
            <Typography variant="h3" mb={3}>Security</Typography>
            <form onSubmit={submitChangePass}>
              <Box display="flex" flexDirection="column" gap={3}>
                <TextField
                  fullWidth
                  label="Old Password"
                  type="password"
                  onChange={e => setOldPassword(e.target.value)}
                  InputProps={{ startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
                />
                <TextField
                  fullWidth
                  label="New Password"
                  type="password"
                  onChange={e => setPassword(e.target.value)}
                  InputProps={{ startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
                />
                <TextField
                  fullWidth
                  label="Repeat New Password"
                  type="password"
                  onChange={e => setPassword2(e.target.value)}
                  InputProps={{ startAdornment: <VpnKeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
                />
                <Button type="submit" variant="contained" color="primary" alignSelf="flex-start">
                  Update Password
                </Button>
              </Box>
            </form>
          </Paper>
        </Box>
      )}
    </Box>
  );
}

export default Account;